module.exports = __webpack_public_path__ + "static/media/salarie.85550e99.svg";